export const INPUT_TYPE = {
  TEXT: "text",
  NUMBER: "number",
  EMAIL: "email",
  PASSWORD: "password",
  TEXTAREA: "textarea",
  SELECT: "select",
  DATE: "date",
  ADDRESS: "address",
  PLAQUE: "plaque",
  MULTISELECT: "multiselect",
  ZONE: "zone",
  WEEKDAYS: "weekdays",
  TIME: "time",
  CHECKBOX: "checkbox",
  COLOR: "color",
  FILE: "file",
  RANGEDATE: "rangeDate",
  PRICE: "price",
  SIMPLE_SWITCH: "simple_switch",
  TWO_LABEL_SWITCH: "two_label_switch",
  RADIO: "radio",
  CUSTOM: "custom",
};
